import React from 'react'
import Routing, { SideMenu } from '../../components/reusable/routing'

import ByItems from './ByItems'
import ByPatient from './ByPatients'
import ByDiagnoses from './ByDiagnoses'
import ByStaff from './ByStaff'

import Visits from './operational/Visits'
import Patients from './operational/Patients'
import Process from './operational/Process'
import Inventory from './operational/Inventory'

const Reports = () => {
    let menu = [
        {
            path: 'op-analysis',
            title: 'Operational Analysis',
            submenu: [
                {
                    path: 'visit-analysis',
                    title: 'Visit Analysis',
                    component: Visits
                },
                {
                    path: 'patient',
                    title: 'Patient',
                    component: Patients
                },
                {
                    path: 'clinical-processes',
                    title: 'Clinical Processes',
                    component: Process
                },
                {
                    path: 'inventory',
                    title: 'Inventory',
                    component: Inventory
                },
                {
                    path: 'service-backlog',
                    title: 'Service Backlog'
                }
            ]
        },
        {
            path: 'collection-analysis',
            title: 'Collection Analysis',
            submenu: [
                {
                    path: 'unit-monthly-summary',
                    title: 'Unit Monthly Summary',
                },
                {
                    path: 'payment-method-summary',
                    title: 'Payment Method Summary'
                },
                {
                    path: 'cashier-collection',
                    title: 'Cashier Collection'
                },
                {
                    path: 'category-collection-analysis',
                    title: 'Category Collection Analysis'
                },
                {
                    path: 'category-payment-method',
                    title: 'Category Payment Method'
                }
            ]
        },
        {
            path: 'revenue-analysis',
            title: 'Revenue Analysis',
            submenu: [
                {
                    path: 'sale-items',
                    title: 'Sale Items',
                },
                {
                    path: 'department-unit',
                    title: 'Department / Unit'
                },
                {
                    path: 'department-total',
                    title: 'Department Total'
                },
                {
                    path: 'inpatient-outpatient',
                    title: 'Inpatient / Outpatient'
                },
                {
                    path: 'staff',
                    title: 'Staff'
                }
            ]
        },
        {
            path: 'financial-statements',
            title: 'Financial Statements',
            submenu: [
                {
                    path: 'trial-balance',
                    title: 'Trial Balance',
                },
                {
                    path: 'income-statement',
                    title: 'Income Statement'
                },
                {
                    path: 'balance-sheet',
                    title: 'Balance Sheet'
                },
                {
                    path: 'cash-flow-statement',
                    title: 'Cash Flow Statement'
                }
            ]
        },
        {
            path: 'medical-reports',
            title: 'Medical Reports',
            submenu: [
                {
                    path: 'clinical-reports',
                    title: 'Clinical Reports',
                },
                {
                    path: 'operational',
                    title: 'Operational'
                }
            ]
        },
        {
            path: 'inventory',
            title: 'Inventory Reports',
            submenu: [
                {
                    path: 'clinical-reports',
                    title: 'Clinical Reports',
                },
                {
                    path: 'operational',
                    title: 'Operational'
                }
            ]
        },
        {
            path: 'workload-reports',
            title: 'Workload Reports',
            submenu: [
                {
                    path: 'registration-workload',
                    title: 'Registration Workload',
                },
                {
                    path: 'billing-workload',
                    title: 'Billing Workload'
                },
                {
                    path: 'clinician-workload',
                    title: 'Clinician Workload'
                },
                {
                    path: 'nurses-workload',
                    title: 'Nurses Workload'
                },
                {
                    path: 'imaging-workload',
                    title: 'Imaging Workload'
                },
                {
                    path: 'lab-workload',
                    title: 'Lab Workload'
                },
                {
                    path: 'pharmacy-workload',
                    title: 'Pharmacy Workload'
                }
            ]
        },
        // {
        //     path: '',
        //     title: 'By Item',
        //     component: ByItems
        // },
        // {
        //     path: 'visits',
        //     title: 'Visits',
        //     // component: Visits
        // },
        // {
        //     path: 'by-diagnoses',
        //     title: 'By Diagnoses',
        //     component: ByDiagnoses
        // },
        // {
        //     path: 'by-patient',
        //     title: 'By Patient',
        //     component: ByPatient
        // },
        // {
        //     path: 'by-staff',
        //     title: 'By Staff',
        //     component: ByStaff
        // }
    ]

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Reports</p>
                <SideMenu namespace="reports" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="reports" menu={ menu } />
            </div>
        </div>
    )
}

export default Reports